export default __webpack_public_path__ + "static/media/community.72874e06.png";